import { create } from 'zustand';
import { syncService } from '../services/syncService';

interface SyncStartDateState {
  startDate: string | null;
  effectiveStartDate: string;
  fetchStartDate: () => Promise<{ startDate: string | null; effectiveStartDate: string }>;
}

export const useSyncStartDateStore = create<SyncStartDateState>((set) => ({
  startDate: null,
  effectiveStartDate: '',

  // Left uncaught: SyncStartDatePanel's own .catch() drives its 'load-error' status.
  fetchStartDate: async () => {
    const result = await syncService.getSyncStartDate();
    set(result);
    return result;
  },
}));
